import AllTripsContainer from './all-container';

export default AllTripsContainer;
